<template>
  <div>
    <COM_HeaderNav mode="onePageAdv"></COM_HeaderNav>

    <div class="form-group row">
      <div class="col-sm-10">
        <a class="btn btn-primary mybutton" href="#" @click.prevent="submit" style="width: 100px">儲存</a>

        <a role="button" class="btn btn-primary" @click.prevent="switchMode()">{{ModeText}}</a>
      </div>
    </div>



    <a class="btn btn-primary" @click="DataItem_AddLast"><i class="fas fa-plus-circle"></i></a>
    <table class="table table-hover" id="tblSecond">
      <thead class="thead-light">
      <tr>
        <th class="text-center">功能</th>
        <th>名稱</th>
        <th v-if="ready && datas.UseCNameFeature">網域CName (www等)</th>
        <th>是否顯示</th>
<!--        <th>是否啟用</th>-->
        <th>說明</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item,index) in this.datas.Details" :key="index">
        <td class="" style="width: 300px">
          <a class="btn btn-primary" @click="DataItem_Edit(item)"><i class="fa fa-pen"></i>編輯頁面</a>
          <a class="btn btn-danger" @click="DataItem_Remove(item)"><i class="fa fa-trash"></i></a>
          <a class="btn btn-primary" @click="DataItem_MoveUp(item)"><i class="fa fa-angle-up"></i> </a>
          <a class="btn btn-primary" @click="DataItem_MoveDown(item)"><i class="fa fa-angle-down"></i> </a>
        </td>
        <td width="120px">
          <input type="text" class="form-control" placeholder="" v-model="item.Name">
        </td>
        <td width="120px">
          <input type="text" class="form-control" placeholder="" v-model="item.CName">

        </td>
        <td width="120px" v-if="ready && datas.UseCNameFeature">
          <select class="form-control" style="width: 100px" v-model="item.IsVisible">
            <option :value="true">顯示</option>
            <option :value="false">隱藏</option>

          </select>
        </td>
<!--        <td width="120px">-->
<!--          <select class="form-control" style="width: 100px" v-model="item.IsEnable">-->
<!--            <option :value="true">啟用</option>-->
<!--            <option :value="false">停用</option>-->
<!--          </select>-->
<!--        </td>-->
        <td width="120px">
          <input type="text" class="form-control" placeholder="" v-model="item.Memo">
        </td>
<!--        <td width="100px">-->
<!--          <input type="number" class="form-control" placeholder="" v-model="item.Month">-->
<!--        </td>-->
<!--        <td>-->
<!--          <select class="form-control" v-model="item.Type">-->
<!--            <option></option>-->
<!--            <option value="USD">USD</option>-->
<!--            <option value="EUR">EUR</option>-->
<!--            <option value="GBP">GBP</option>-->
<!--            <option value="CHF">CHF</option>-->
<!--          </select>-->
<!--        </td>-->
<!--        <td>-->
<!--          <input type="number" class="form-control" placeholder="" v-model="item.Rate">-->
<!--        </td>-->
      </tr>

      </tbody>
    </table>


  </div>
</template>

<script>
import arrayUtil from "@/pages/common/arrayUtil";
import util from "@/pages/common/util";
import apiUBossOnePageBk from "@/pages/ubossBk/util/apiUBossOnePageBk";
import COM_HeaderNav from "@/pages/ubossBk/views/components/COM_HeaderNav";

let configEditPage="OnePageAdvEdit";

export default {
  components: {COM_HeaderNav},
  data: function () {
    return {
      id: "",
      formData: {
        name: "",
      },
      datas:{

      },
      ready:false,
    };
  },
  computed:{
    ModeText(){
      return this.datas.UseCNameFeature ? "不使用CName 來區別頁面":"使用CName 來區別頁面";
    }
  },
  methods: {
    async loadData() {
      let data=await apiUBossOnePageBk.api_Get_OnePageAdv()

      this.datas=data
      this.ready=true;
    },
    submit(){
      for (let i = 0; i < this.datas.Details.length; i++) {
        let item = this.datas.Details[i];

        if (item.Name===""){
          util.showErrorMessage("第"+i+1+" 行，「名稱」為必填欄位")
          return;
        }
      }

      apiUBossOnePageBk.api_Save_OnePageAdv(this.datas.SystemId,this.datas).then(()=>{
        util.ShowMessage('儲存成功')
      })
    },
    DataItem_AddLast(){
      let newItem={
        SystemId:util.uuid(),
        Name:"",
        IsVisible:true,
        IsEnable:true,
        Memo:"",
        OrderKey:"0",
      }

      arrayUtil.orderAppendLast(newItem,this.datas.Details,"OrderKey")
    },
    DataItem_Edit(item){
      this.$router.push({ name: configEditPage, query: { systemId: item.SystemId }})
    },
    DataItem_MoveUp(item){
      arrayUtil.orderMove(false,item.SystemId,this.datas.Details,"SystemId","OrderKey")
    },
    DataItem_MoveDown(item){
      arrayUtil.orderMove(true,item.SystemId,this.datas.Details,"SystemId","OrderKey")
    },

    DataItem_Remove(item){
      if (!window.confirm("確定刪除?")) {
        return
      }
      this.datas.Details= this.datas.Details.filter(s => s.SystemId !==item.SystemId);
    },
    switchMode(){
      this.datas.UseCNameFeature=!this.datas.UseCNameFeature;
    },

  },
  mounted() {
    this.loadData()
  },
}
</script>

<style scoped>
  #tblMain{
    width: 800px;
  }
  #tblSecond{
    width: 1000px;
  }
  .btn{
    color: white !important;
    margin: 5px;
    /*width: 40px;*/
  }
</style>
